var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-menu-item',{attrs:{"target-path":"account-settings","title":"הגדרות מנוי","icon":_vm.icon},on:{"navigate":function($event){return _vm.$emit('navigate')}}})}
var staticRenderFns = []

export { render, staticRenderFns }